import { DeleteOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

export const ProductionItemsColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
) => {
  return [
    // {
    //   title: "Item No",
    //   dataIndex: "ProductionItemNo",
    //   key: "ProductionItemNo",
    //   onHeaderCell: () => ({ onClick: () => {} }),
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="ProductionNo"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "ProductionNo",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },

    {
      title: "Hardware",
      dataIndex: "Hardware",
      key: "Hardware",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionDesc"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionDesc",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "OEM",
      dataIndex: "Oem",
      key: "Oem",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionName"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionName",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Product",
      dataIndex: "Product",
      key: "Product",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionName"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionName",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "License",
      dataIndex: "License",
      key: "License",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="ProductionTime"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "ProductionTime",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Item Count",
      dataIndex: "ItemCount",
      key: "ItemCount",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="OemNo"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "OemNo",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },
    {
      title: "Device Count",
      dataIndex: "DeviceCount",
      key: "DeviceCount",
      onHeaderCell: () => ({ onClick: () => {} }),

      //   sorter: (a, b) => () => {},
      //   sortIcon: () => (
      //     <SortIcon
      //       sortOrder={modParams.order}
      //       columnKey="OemNo"
      //       sortBy={modParams.sort_by}
      //     />
      //   ),
      //   onHeaderCell: () => ({
      //     onClick: () =>
      //       setParams((prev) => ({
      //         ...modParams,
      //         sort_by: "OemNo",
      //         order: modParams.order === "desc" ? "asc" : "desc",
      //       })),
      //   }),
    },

    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      //   render: (text, record, rowIndex) =>
      //     hoveredRow === rowIndex ? (
      //       <div className="absolute top-2 right-5">
      //         <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
      //           {/* <Tooltip title="Edit">
      //             <div className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 ">
      //               <Link
      //                 to={`/production/edit/${record?.ProductionNo}`}
      //                 onClick={(e) => e.stopPropagation()}
      //                 className=" hover:text-[#636262ee]"
      //               >
      //                 <EditOutlined />
      //               </Link>
      //             </div>
      //           </Tooltip> */}
      //           <Tooltip title="Delete">
      //             <div
      //               onClick={(e) => {
      //                 e.stopPropagation();
      //                 setShowModal(true);
      //                 setSelectedRowKeys([record?.ProductionItemNo]);
      //               }}
      //               className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
      //             >
      //               <DeleteOutlined />
      //             </div>
      //           </Tooltip>
      //         </div>
      //       </div>
      //     ) : null,
    },
  ];
};
